export enum SolicitorNotificationStatusEnum {
  case_received = "CASE_RECEIVED",
  ipa_received = "IPA_RECEIVED",
  rejected = "REJECTED",
  cancelled = "CANCELLED",
  removed = "REMOVED",
  no_action = "NO_ACTION",
}